import { Link, Outlet, useParams } from "react-router-dom";
import { api } from "../api/client";
import { useResource } from "../api/resource";
import { DocumentPanel, UploadDialog } from "../components/documents";
import { DossierShell, Header } from "../components/shell";
import { EmptyState, ErrorState, SkeletonBlock } from "../components/ui";
import { DossierProvider } from "../dossier";
import { w } from "../i18n";

/** Loads the dossier named in the URL, then renders the workspace around the page. */
export function DossierLayout() {
  const { dossierId = "" } = useParams();
  const dossier = useResource(`dossier:${dossierId}`, () => api.getDossier(dossierId));

  if (!dossier.data) {
    return <div className="ws-app"><Header /><main className="ws-main"><div className="ws-main-inner">
      {dossier.loading && <SkeletonBlock lines={6} />}
      {dossier.error?.status === 404 && <EmptyState title={dossier.error.message}
        action={<Link className="ws-btn" to="/?pick=1">{w("nav.switchDossier")}</Link>} />}
      {dossier.error && dossier.error.status !== 404 && <ErrorState title={w("common.genericError")} error={dossier.error} onRetry={dossier.reload} />}
    </div></main></div>;
  }

  return <DossierProvider dossier={dossier.data} overlays={(state, close) => <>
    {state.upload.open && <UploadDialog versionOf={state.upload.versionOf} onClose={close.upload} />}
    {state.inspected && <DocumentPanel documentId={state.inspected} onClose={close.inspect} />}
  </>}>
    <DossierShell><Outlet /></DossierShell>
  </DossierProvider>;
}
